/* eslint-disable camelcase */
import { useState, useCallback } from 'react';
import { RESPONSE_TYPES } from 'ai/constants/superchat';

const useSuperChatFeedback = ({ messages, setMessages }) => {
    const [showFlyer, setShowFlyer] = useState(false);
    const [showFeedbackInMessages, setShowFeedbackInMessages] = useState(false);

    const toggleFlyer = useCallback(() => {
        setShowFlyer(prev => !prev);
    }, []);

    const showFeedback = useCallback(() => {
        const hasFeedbackMessage = messages.some(message => message.response_type === RESPONSE_TYPES.FEEDBACK_COLLECTION);

        if (showFeedbackInMessages || hasFeedbackMessage) {
            setShowFlyer(false);

            return;
        }

        setShowFlyer(false);
        setShowFeedbackInMessages(true);

        const feedbackMessage = {
            response_type: RESPONSE_TYPES.FEEDBACK_COLLECTION,
            timestamp: Date.now()
        };
        setMessages(prev => [...prev, feedbackMessage]);
    }, [messages, showFeedbackInMessages, setMessages]);

    const closeFeedback = useCallback(() => {
        setShowFeedbackInMessages(false);
        setMessages(prev => prev.filter(message => message.response_type !== RESPONSE_TYPES.FEEDBACK_COLLECTION));
    }, [setMessages]);

    return {
        showFlyer,
        showFeedbackInMessages,
        toggleFlyer,
        showFeedback,
        closeFeedback
    };
};

export default useSuperChatFeedback;
